import React from 'react';
import {useSurveyButton} from 'shared/components/Surveys/helpers/useSurveyButton';
import {SURVEYS} from 'shared/components/Surveys/helpers/useSurveys';
import {FloatingButton} from 'shared/components/Header/RoomPlanner/FloatingButton';

export const SurveyButton = () => {
    const {showButton, showSurveyForm} = useSurveyButton(SURVEYS.RoomPlanner);

    if (!showButton) return null;

    return (
        <FloatingButton
            onClick={showSurveyForm}
            icon="Survey-Secondary.svg"
            title="Provide feedback"
        />
    );
};
